/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React, { useContext } from 'react';
import { connect, useSelector } from 'react-redux';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import CmsContext from 'context/CmsContext';
import TagRequirements from './requirements/container/RequirementsTagging';
import TempRequirementsTagging from './requirements/container/TempRequirementsTagging';
import OrdinanceRevisionContainer from './ordinanceRevision/container/OrdinanceRevisionContainer';
import TaxRevenueTypesContainer from './taxRevenueTypes/container/TaxRevenueTypesContainer';
import TaxAmnestyContainer from './taxAmnesty/container/TaxAmnestyContainer';
import DiscountPenaltyContainer from './discountPenalty/container/DiscountPenaltyContainer';
import EndorsingOfficesContainer from './endorsingOffices/container/EndorsingOfficesContainer';
import BusinessLineRequirementsTagging from './requirements/container/BusinessLineRequirementsTagging';
import BarangayProfileContainer from './barangayProfile/container/BarangayProfileContainer';
import FireSafetyContainer from './fireSafety/container/FireSafetyContainer';
// import BusinessLineRequirementsContainer from './businessLineRequirements/container/BusinessLineRequirementsContainer';
import { GET_FORMDATA_ORDINANCE_REVISION } from '../constant';

function SettingsContainer({ match, pathName, fetchedDefaultOption }) {
  const permissions = getJson('permissions');
  const cmsContext = useContext(CmsContext);
  const CMS_COMPONENTS = cmsContext.findByType('COMPONENTS');
  const showFsisIntegration = !!_.get(CMS_COMPONENTS, 'FSIS_INTEGRATION');

  const dropDownFormData = useSelector(
    ({ api }) => _.get(api, `${GET_FORMDATA_ORDINANCE_REVISION}.item`) || {}
  );

  const ordinanceRevisionId =
    parseInt(_.get(dropDownFormData, 'year.value'), 0) ||
    parseInt(_.get(fetchedDefaultOption, 'year.value'), 0) ||
    0;

  return (
    <React.Fragment>
      <div className="card-content-listing">
        <div className="container-fluid">
          <div className="row">
            <ul className="nav nav-tabs btn-settings-tab-container">
              <li className="nav-item">
                {Acl(permissions, ['E2E BPLS REQUIREMENT TAGGING']) && (
                  <Link
                    to="/bpls/settings/tag/requirements"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                      pathName.indexOf('bpls/settings/tag/requirements') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Requirements Tagging
                  </Link>
                )}
              </li>
              <li className="nav-item">
                {Acl(permissions, [
                  'BPLS BUSINESS LINE REQUIREMENT TAGGING',
                ]) && (
                  <Link
                    to="/bpls/settings/tag/business-line-requirements"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                      pathName.indexOf(
                        'bpls/settings/tag/business-line-requirements'
                      ) > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Business Line Requirements Tagging
                  </Link>
                )}
              </li>
              <li className="nav-item">
                {Acl(permissions, ['VIEW BPLS ORDINANCE REVISION']) && (
                  <Link
                    to="/bpls/settings/ordinance-revision"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                      pathName.indexOf('bpls/settings/ordinance-revision') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Ordinance Revision
                  </Link>
                )}
              </li>
              <li className="nav-item">
                {Acl(permissions, ['E2E BPLS TAX AMNESTY']) && (
                  <Link
                    to="/bpls/settings/tax-amnesty"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                      pathName.indexOf('bpls/settings/tax-amnesty') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Tax Amnesty
                  </Link>
                )}
              </li>
              <li>
                {Acl(permissions, ['E2E BPLS DISCOUNT PENALTY']) && (
                  <Link
                    to="/bpls/settings/discount-penalty"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                      pathName.indexOf('bpls/settings/discount-penalty') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Discount and Penalty
                  </Link>
                )}
              </li>
              <li>
                {Acl(permissions, ['VIEW ENDORSING OFFICES']) && (
                  <Link
                    to="/bpls/settings/endorsing-offices"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                      pathName.indexOf('bpls/settings/endorsing-offices') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Endorsing Offices
                  </Link>
                )}
              </li>
              <li className="nav-item">
                {Acl(permissions, ['VIEW TAX REVENUE TYPES']) && (
                  <Link
                    to="/bpls/settings/tax-revenue-types"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                      pathName.indexOf('bpls/settings/tax-revenue-types') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Tax Revenue Types
                  </Link>
                )}
              </li>
              <li className="nav-item">
                {Acl(permissions, ['MANAGE BARANGAY PROFILES']) && (
                  <Link
                    to="/bpls/settings/barangay-profile"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                      pathName.indexOf('bpls/settings/barangay-profile') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Barangay Profile
                  </Link>
                )}
              </li>
              {showFsisIntegration && (
                <li className="nav-item">
                  <Link
                    to="/bpls/settings/fsis-integration"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                      pathName.indexOf('bpls/settings/fsis-integration') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    FSIS Integration
                  </Link>
                </li>
              )}
              {/* <li>
                {Acl(permissions, ['E2E BPLS DISCOUNT PENALTY']) && (
                  <Link
                    to="/bpls/settings/business-line-requirements"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                      pathName.indexOf('bpls/settings/business-line-requirements') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Business Line Requirements
                  </Link>
                )}
              </li> */}
            </ul>
          </div>
        </div>
        <Switch>
          <Route
            exact
            path={`${match.path}`}
            render={() => <Redirect to={`${match.path}/tag/requirements`} />}
          />
          {Acl(permissions, ['E2E BPLS REQUIREMENT TAGGING']) && (
            <Route
              path={`${match.path}/tag/requirements`}
              component={TagRequirements}
            />
          )}
          {Acl(permissions, ['BPLS BUSINESS LINE REQUIREMENT TAGGING']) && (
            <Route
              path={`${match.path}/tag/business-line-requirements`}
              component={BusinessLineRequirementsTagging}
            />
          )}
          {Acl(permissions, ['VIEW BPLS ORDINANCE REVISION']) && (
            <Route
              path={`${match.path}/ordinance-revision`}
              component={OrdinanceRevisionContainer}
            />
          )}
          {Acl(permissions, ['E2E BPLS TAX AMNESTY']) && (
            <Route
              path={`${match.path}/tax-amnesty`}
              component={TaxAmnestyContainer}
            />
          )}
          {Acl(permissions, ['E2E BPLS DISCOUNT PENALTY']) && (
            <Route
              path={`${match.path}/discount-penalty`}
              render={() => (
                <DiscountPenaltyContainer
                  ordinanceRevisionId={ordinanceRevisionId}
                />
              )}
            />
          )}
          {Acl(permissions, ['VIEW ENDORSING OFFICES']) && (
            <Route
              path={`${match.path}/endorsing-offices`}
              component={EndorsingOfficesContainer}
            />
          )}
          {Acl(permissions, ['VIEW TAX REVENUE TYPES']) && (
            <Route
              path={`${match.path}/tax-revenue-types`}
              component={TaxRevenueTypesContainer}
            />
          )}
          {Acl(permissions, ['MANAGE BARANGAY PROFILES']) && (
            <Route
              path={`${match.path}/barangay-profile`}
              component={BarangayProfileContainer}
            />
          )}
          {showFsisIntegration && (
            <Route
              path={`${match.path}/fsis-integration`}
              component={FireSafetyContainer}
            />
          )}
          {/* <Route 
            path={`${match.path}/business-line-requirements`}
            component={BusinessLineRequirementsContainer}
          /> */}
        </Switch>
      </div>
    </React.Fragment>
  );
}

SettingsContainer.defaultProps = {
  fetchedDefaultOption: {},
};

SettingsContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
  fetchedDefaultOption: PropTypes.instanceOf(Object),
};

const mapStateToProps = ({ api }, { match, location }) => {
  const fetchDefaultOption = () => {
    try {
      return JSON.parse(localStorage.getItem('defaultFormValue'));
    } catch (err) {
      return {};
    }
  };

  return {
    mainModule: _.get(match, 'params.mainModule'),
    pathName: _.get(location, 'pathname'),
    profile: _.get(api, 'AUTH/user_profile.item') || {},
    fetchedDefaultOption: fetchDefaultOption(),
  }
};

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(SettingsContainer);
